import { MAIN_ROUTES, SUB_ROUTES } from '@/router/components';
import { BackgroundColors } from '@/@types/types';

export default {
  path: '/data-catalog',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.data-catalog',
  },
  component: MAIN_ROUTES.CATALOG,
  children: [
    {
      path: '',
      name: 'data-catalog',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'app.navigation-drawer.data-catalog',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'legacy',
      name: 'data-catalog-legacy',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'app.navigation-drawer.data-catalog',
        background: BackgroundColors.SECONDARY,

      },
      component: SUB_ROUTES.CATALOG_SEARCH,
    },
    {
      path: 'asset-next/:urn/*',
      name: 'data-catalog-asset-next',
      meta: {
        requiresAuth: true,
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'asset/:urn',
      name: 'data-catalog.asset',
      meta: {
        requiresAuth: true,
        breadCrumb: 'Asset Overview',
        breadCrumbFromParamName: true,
        params: ['urn'],
      },
      props: true,
      component: SUB_ROUTES.ASSET,
      redirect: {
        name: 'data-catalog.asset.overview',
      },
      children: [
        {
          path: 'overview',
          name: 'data-catalog.asset.overview',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset Overview',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_OVERVIEW,
        },
        {
          path: 'history',
          name: 'data-catalog.asset.history',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            background: BackgroundColors.SECONDARY,

          },
          component: () => import('@/views/FrontendNextRouteView.vue'),
          children: [
            {
              path: 'update-history',
              name: 'data-catalog.asset.history.queries-updates',
              props: true,
              meta: {
                hideBreadCrumb: true,
                background: BackgroundColors.SECONDARY,
              },
              component: () => import('@/views/FrontendNextRouteView.vue'),
            },
            {
              path: 'popular-queries',
              name: 'data-catalog.asset.history.queries-popular',
              props: true,
              meta: {
                hideBreadCrumb: true,
                background: BackgroundColors.SECONDARY,
              },
              component: () => import('@/views/FrontendNextRouteView.vue'),
            },
          ],
        },
        {
          path: 'dbt',
          name: 'data-catalog.asset.dbt',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset dbt metadata',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_DBT,
        },
        {
          path: 'dbt_runs',
          name: 'data-catalog.asset.dbt_runs',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset dbt runs metadata',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_DBT_RUNS,
        },
        {
          path: 'schema',
          name: 'data-catalog.asset.schema',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset Schema',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_SCHEMA,
        },
        {
          path: 'monitors',
          name: 'data-catalog.asset.monitors',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Monitors',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_MONITORS,
        },
        {
          path: 'incidents',
          name: 'data-catalog.asset.incidents',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Incidents',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_INCIDENTS,
        },
        {
          path: 'lineage',
          name: 'data-catalog.asset.lineage',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset Lineage',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_LINEAGE,
        },
        {
          path: 'documentation',
          name: 'data-catalog.asset.documentation',
          props: true,
          meta: {
            requiresAuth: true,
            hideBreadCrumb: true,
            breadCrumb: 'Asset Documentation',
            background: BackgroundColors.SECONDARY,

          },
          component: SUB_ROUTES.ASSET_DOCUMENTATION,
        },
      ],
    }],
};
